import { RidangoReduxAction } from '@ridango/core';
import { ProductsSelectorActions } from './products-selector.actions';

export const PRODUCTS_SELECTOR_STATE_KEY = 'productsSelector';

export interface ProductsSelectorState {
    selected: Map<number, number>;
}

export const PRODUCTS_SELECTOR_INITIAL_STATE: ProductsSelectorState = {
    selected: new Map<number, number>(),
};

export function productsSelectorReducer(
    state: ProductsSelectorState = PRODUCTS_SELECTOR_INITIAL_STATE,
    action: RidangoReduxAction
): ProductsSelectorState {
    switch (action.type) {
        case ProductsSelectorActions.ADD_PRODUCT:
            return {
                ...state,
                selected: addProductToSelection(action.payload, { ...state.selected }),
            };
        case ProductsSelectorActions.REMOVE_PRODUCT:
            return {
                ...state,
                selected: removeProductFromSelection(action.payload, { ...state.selected }),
            };
        case ProductsSelectorActions.CLEAR_PRODUCT_COUNTS:
            return {
                ...state,
                selected: new Map<number, number>(),
            };
        default:
            return state;
    }
}

function addProductToSelection(productId: number, selected: Map<number, number>): Map<number, number> {
    if (selected[productId]) {
        selected[productId] += 1;
    } else {
        selected[productId] = 1;
    }

    return selected;
}

function removeProductFromSelection(productId: number, selected: Map<number, number>): Map<number, number> {
    if (selected[productId] <= 1) {
        delete selected[productId];
    } else {
        selected[productId] -= 1;
    }

    return selected;
}

export interface ProductsSelectorPartialStoreState {
    [PRODUCTS_SELECTOR_STATE_KEY]: ProductsSelectorState;
}
